import LineUpPage from '../../layouts/lineUpPage'

const LineUp: React.FC = () => {
    return <LineUpPage />;
};

export default LineUp;
